import firebase from "../../config/firebase";

export const getChangeAdminRequests =
  (id, onComplete = () => {}) =>
  async (dispatch) => {
    firebase
      .firestore()
      .collection("change_school_admin_requests")
      .where("schoolAdminId", "==", id)
      .get()
      .then(async (query) => {
        let temp_data = [];
        for await (let doc of query.docs) {
          temp_data.push({ ...doc.data(), id: doc.id });
        }
        dispatch({
          type: "GET_ADMIN_CHANGE_REQUESTS",
          payload: temp_data,
        });
        onComplete();
      });
  };
export const rejectRequest =
  (id, onComplete = () => {}) =>
  async (dispatch) => {
    await firebase
      .firestore()
      .collection("change_school_admin_requests")
      .doc(id)
      .delete();
    dispatch({
      type: "REJECT_REQUEST",
      payload: id,
    });
    onComplete();
  };
export const acceptRequest =
  (id, onComplete = () => {}) =>
  async (dispatch) => {
    await firebase
      .firestore()
      .collection("change_school_admin_requests")
      .doc(id)
      .update({
        status: "fhp admin pending",
      });
    let notificationData = {
      type: "collective-admin-change",
      notifyID: id,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      status: false,
    };
    await firebase
      .firestore()
      .collection("admin_notifiaction")
      .add(notificationData);
    dispatch({
      type: "ACCEPT_REQUEST",
      payload: id,
    });
    onComplete();
  };
